import { render, staticRenderFns } from "./PaymentMethodsNew.vue?vue&type=template&id=3e603574&scoped=true&"
import script from "./PaymentMethodsNew.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodsNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e603574",
  null
  
)

export default component.exports